import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Switch, Route, withRouter } from 'react-router-dom';

import useOnMount from '../hooks/useOnMount';
import { theme } from '../components/global';
import Apartment from '../views/apartment';
import NotFound from '../views/notFound';
import Application from '../views/application';
import Loading from '../components/loading';
import { routeLocationUpdated } from '../actions/pageActions';
import linkResolver from '../helpers/linkResolver/linkResolver';
import StyledRouteTransitions from './routeTransitions.styles';
import mappedRoutes from './routeConfig';
import GrindavikApplication from '../views/application/grindavikApplication';

const Routes = ({
	dispatch,
	routes,
	history,
	location
}) => {
	useOnMount(() => {
		history.listen(loc => dispatch(routeLocationUpdated(linkResolver(loc.pathname))));
	});

	return (
		<StyledRouteTransitions>
			<Loading />
			<TransitionGroup>
				<CSSTransition
					key={location.key}
					timeout={{ enter: theme.routeTransitions.enterDuration, exit: theme.routeTransitions.exitDuration }}
					classNames="fade">
					<div>
						<Switch location={location}>
							<Route exact path="/umsokn/:id" component={Application} />
							<Route exact path="/ibud/:id" component={Apartment} />
							<Route exact path="/grindavik/umsokn/:id" component={GrindavikApplication} />
							<Route exact path="/grindavik/ibud/:id" component={Apartment} />
							{mappedRoutes(routes)}
							<Route component={NotFound} />
						</Switch>
					</div>
				</CSSTransition>
			</TransitionGroup>
		</StyledRouteTransitions>
	);
};

export default withRouter(Routes);
